import { ReduxData } from '../types';

const SET = 'data/SET';
const UNSET = 'data/UNSET';

type Payload = Partial<ReduxData>;

export const setData = (payload: Payload, type = SET) => ({
  type,
  payload,
  meta: { data: SET },
});

export const unsetData = (payload: any, type = UNSET) => ({
  type,
  payload,
  meta: { data: UNSET },
});

export const reducer = (state = {}, action: any) => {
  switch (action && action.meta && action.meta.data) {
    case SET: {
      return Object.assign({}, state, action.payload);
    }
    case UNSET: {
      const nextState = Object.assign({}, state);
      action.payload.forEach((key: string) => delete nextState[key]);
      return nextState;
    }
    default: {
      return state;
    }
  }
};
